import { useEffect, useState } from 'react';
import { permisosService } from '../services/permisosService';

export const usePermisos = (rol) => {
  const [permisos, setPermisos] = useState([]);
  const [roles, setRoles] = useState([]);
  const [filtrados, setFiltrados] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await permisosService.getAll();

        const { roles, permisos } = data;
        
        setRoles(roles);
        setPermisos(permisos);

      } catch (error) {
        console.error('Error cargando permisos', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (rol) {
      setFiltrados(permisosService.getByRol(permisos, rol));
    } else {
      setFiltrados([]);
    }
  }, [rol, permisos]);

  return { roles, permisos: filtrados };
};